var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "122px",
    viewBox: "0 0 360 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2,0.2 C33.7,0.2 30.9,3 30.9,6.5 L30.9,83.6 C31.1,91 28.2,98 22.8,103.4 C20,106.2 16.6,108.4 12.7,109.9 C11.1,110.5 9.8,111.6 9.1,113.1 C8.4,114.6 8.3,116.4 8.9,118 C9.8,120.5 12.2,122.2 14.8,122.2 C15.6,122.2 16.3,122.1 17,121.8 C22.6,119.7 27.8,116.4 31.8,112.4 C39.4,104.8 43.6,94.6 43.6,83.5 L43.6,6.5 C43.6,3 40.8,0.2 37.2,0.2",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1,0.1 C112.5,0.1 109.7,2.9 109.7,6.4 L109.7,48.1 C109.7,58.7 101.1,67.4 90.4,67.4 C79.9,67.4 71.3,58.8 71.3,48.1 L71.3,6.3 C71.3,2.8 68.5,0 64.9,0 C61.4,0 58.6,2.8 58.6,6.3 L58.6,48.3 C58.8,65.8 73,80 90.4,80 C107.9,80 122.2,65.8 122.4,48.2 L122.4,6.3 C122.4,2.9 119.6,0.1 116.1,0.1",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2,0.1 C199.7,0.1 185.4,14.3 185.2,31.9 L185.2,73.8 C185.2,77.3 188,80.1 191.5,80.1 C195.1,80.1 197.9,77.3 197.9,73.8 L197.9,32 C197.9,21.4 206.5,12.7 217.2,12.7 C227.7,12.7 236.3,21.3 236.3,32 L236.3,73.7 C236.3,77.2 239.1,80 242.7,80 C246.2,80 249,77.2 249,73.7 L249,31.7 C248.8,14.3 234.5,0.1 217.2,0.1",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5,0.1 C170.8,0.1 170.1,0 169.4,0 C151.9,0 137.6,14.2 137.4,31.8 L137.4,73.3 C137.4,76.8 140.1,79.8 143.5,79.9 C147.2,80 150.1,77.2 150.1,73.6 L150.1,33.1 C150.1,23.1 157.3,14 167.3,12.9 C168.5,12.8 169.7,12.8 170.9,12.8 C173.7,13 176.2,11.3 177.1,8.7 L177.2,8.5 C178.5,4.5 175.7,0.4 171.5,0.1",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,0.6 C317.5,0.6 314.7,3.4 314.7,6.9 L314.7,48.3 C314.7,58.8 306.1,67.4 295.6,67.4 C285.1,67.4 276.5,58.8 276.5,48.3 L276.5,6.8 C276.5,3.3 273.7,0.5 270.2,0.5 C266.7,0.5 263.9,3.3 263.9,6.8 L263.9,48.5 C264.1,65.8 278.3,79.8 295.5,79.8 C301.4,79.8 306.8,78.3 311.7,75.4 L314.6,73.7 L314.6,89.1 C314.6,100 305.7,108.9 294.7,108.9 C287.2,108.9 280.3,104.7 276.8,97.8 C275.8,95.7 273.6,94.3 271.2,94.3 C270.3,94.3 269.4,94.5 268.5,94.9 C267,95.6 265.8,96.9 265.2,98.6 C264.7,100.2 264.8,101.9 265.5,103.4 C271.1,114.7 282.2,121.7 294.7,121.7 C312.7,121.7 327.3,107.1 327.3,89.2 L327.3,6.8 C327.4,3.3 324.6,0.6 321,0.6",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,8.8 C17.1,4.1 13.3,0.2 8.5,0.2 C3.7,0.2 0,4.1 0,8.8 C0,13.5 3.8,17.4 8.6,17.4 C13.4,17.4 17.1,13.5 17.1,8.8",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,62.9 C346.3,62.9 342.4,66.7 342.4,71.5 C342.4,76.2 346.2,80.1 351,80.1 C355.7,80.1 359.6,76.3 359.6,71.5 C359.6,66.7 355.7,62.9 351,62.9",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f30513317e5a0b9e7b0f6e27e09fef42.svg";
export { ForwardRef as ReactComponent };